
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PuttSituation } from "@/types/golf";
import { TestResult } from "@/types/results";
import { useTranslation } from "react-i18next";

type ApproachResultsProps = {
  approachSituations: PuttSituation[];
  results: TestResult[];
  totalPoints: number;
  totalIndex: number;
};

export const ApproachResults = ({ approachSituations, results, totalPoints, totalIndex }: ApproachResultsProps) => {
  const { t } = useTranslation('results');
  
  console.log('ApproachResults - approachSituations:', approachSituations.length);
  console.log('ApproachResults - results:', results.length);
  console.log('ApproachResults - results situation_ids:', results.map(r => r.situation_id));
  
  // Filtrer les résultats pour ne garder que ceux des approches
  const approachResults = results.filter(r => r.situation_id >= 7 && r.situation_id <= 15);
  console.log('ApproachResults - filtered approach results:', approachResults.length);
  
  // Grouper les résultats par situation_id et prendre le plus récent
  const latestResultsBySituation = approachSituations.map(situation => {
    const situationResults = approachResults.filter(r => r.situation_id === situation.id);
    // Trier par date décroissante et prendre le premier (le plus récent)
    const latestResult = situationResults.sort((a, b) => 
      new Date(b.test_date).getTime() - new Date(a.test_date).getTime()
    )[0];
    return { situation, result: latestResult };
  });
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl text-golf-700">{t('approach.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-12">{t('table.point')}</TableHead>
              <TableHead>{t('table.situation')}</TableHead>
              <TableHead className="text-right">{t('table.points')}</TableHead>
              <TableHead className="text-right">{t('table.index')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {latestResultsBySituation.map(({ situation, result }) => (
              <TableRow key={situation.id}>
                <TableCell className="font-medium">{situation.distances[0].point}</TableCell>
                <TableCell>{t(`situations.situation_${situation.id}`)}</TableCell>
                <TableCell className="text-right">{result?.points || "-"}</TableCell>
                <TableCell className="text-right">{result?.index || "-"}</TableCell>
              </TableRow>
            ))}
            <TableRow className="font-bold bg-golf-50">
              <TableCell colSpan={2}>{t('approach.total')}</TableCell>
              <TableCell className="text-right">{totalPoints}</TableCell>
              <TableCell className="text-right">{totalIndex}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
